import { UNIT, mainColor } from '../../constants/theme';
const borderRadiusStyles = {
    borderTopLeftRadius: `${UNIT}px!important`,
    borderTopRightRadius: `${UNIT}px!important`,
    borderBottomLeftRadius: `${UNIT}px!important`,
    borderBottomRightRadius: `${UNIT}px!important`,
};
export const styles = ({
    paperStyle: {
        boxShadow: `1px 3px 5px #ccc`,
        justifyContent: 'center',
        height: '100%'
    },
    chartPaperStyle: {
        backgroundColor: 'white',
        borderRadius: UNIT,
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        padding: 20
    },
    chartContainer: {
        marginBottom: UNIT * 1.25
    },
    flexContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: UNIT * 1.25
    },
    iconStyle: {
        color: 'black',
        fontSize: UNIT * 0.9375
    },
    addIcon: {
        fontSize: UNIT * 2,
        FontWeightProperty: 'bold',
        color: 'black'
    },
    circleLabel: {
        width: UNIT * 0.75,
        height: UNIT * 0.75,
        marginRight: UNIT * 0.625,
        borderRadius: '50%'
    },
    title: {
        fontSize: UNIT,
        FontWeightProperty: 'bold'
    },
    compaignTitle: {
        width: 190,
        fontSize: UNIT * 1.2,
        FontWeightProperty: 'bold'
    },
    flexItem: {
        flex: 1,
        minWidth: UNIT * 9.375
    },
    spacing: {
        FontWeightProperty: 'bold',
        fontSize: UNIT * 0.8
    },
    minSubtitle: {
        color: 'black',
        FontWeightProperty: 'bold',
        fontSize: UNIT
    },
    minValue: {
        FontWeightProperty: 'bold',
        fontSize: UNIT,
        color: `rgba(${mainColor.rgb}, 1)`
    },
    withTopBorder: {
        ...borderRadiusStyles,
        borderBottomLeftRadius: '0px!important',
        borderBottomRightRadius: '0px!important',
    },
    withoutBorder: {
        borderRadius: '0px!important',
    },
    withBottomBorder: {
        ...borderRadiusStyles,
        borderTopLeftRadius: '0px!important',
        borderTopRightRadius: '0px!important',
    },
    modal: {
        marginTop: `${-UNIT * 0.3125}px!important`
    }
});

